/* esm.sh - unist-util-is@6.0.1 */
export * from "/*unist-util-is@6.0.1/esnext/unist-util-is.mjs";
